const vorpal = require('vorpal')();

vorpal
  .command('foo', 'Outputs "bar".')
  .action(function(args, callback) {
    this.log('bar');
    callback();
  });

vorpal
  .command('long', 'long running')
  .action(function(args, callback) {
    setTimeout(function() {
    	console.info('DONE');
    	callback();
    }, 5000);
  })
  .cancel(function() {
  	console.info('CANCEL CALLED');
  });

vorpal
  .delimiter('myapp$')
  .show();